import { isEqual, isPlainObject } from "lodash";

// Banderas internas que no representan un cambio hecho por el usuario.
const IGNORED_KEYS = ["edit", "__typename"];

const compactForComparison = (value) => {
  if (Array.isArray(value)) {
    const items = value.map(compactForComparison);
    return items.length ? items : undefined;
  }

  if (isPlainObject(value)) {
    const entries = Object.entries(value)
      .filter(([key]) => !IGNORED_KEYS.includes(key))
      .map(([key, item]) => [key, compactForComparison(item)])
      .filter(([, item]) => item !== undefined);
    return entries.length ? Object.fromEntries(entries) : undefined;
  }

  return value === null || value === "" ? undefined : value;
};

export const hasUnsavedChanges = (snapshot, current) =>
  !isEqual(compactForComparison(snapshot), compactForComparison(current));

export const getBranchSnapshot = ({ branchSelected, user, arses } = {}) => ({
  branchSelected,
  user,
  arses,
});
